import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_SearchUsersByImageCommand, se_SearchUsersByImageCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class SearchUsersByImageCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "SearchUsersByImage", {})
    .n("RekognitionClient", "SearchUsersByImageCommand")
    .f(void 0, void 0)
    .ser(se_SearchUsersByImageCommand)
    .de(de_SearchUsersByImageCommand)
    .build() {
}
